module.exports = __webpack_public_path__ + "img/200015.41dcb359.png";